import React from "react";
import parse from "html-react-parser";

import i18n from "../../../i18n";

export default function LinkBlock({ item }) {
    return (
        <div>
            {item && i18n.language &&
                <>
                    { item.data['headtext'] && item.data['headtext'][i18n.language] &&
                        <div>
                            <strong>{parse(item.data['headtext'][i18n.language])}</strong>
                        </div>
                    }

                    { item.data['text'] && item.data['text'][i18n.language] &&
                        <div style={{whiteSpace: 'break-spaces'}}>
                            {parse(item.data['text'][i18n.language])}
                        </div>
                    }

                    { item.data['url'] && item.data['url'][i18n.language] && item.data['buttontext'] && item.data['buttontext'][i18n.language] &&
                        <a href={item.data['url'][i18n.language]} target="_blank"
                           className="text-blue-600 underline dark:text-blue-500 hover:no-underline">{item.data['buttontext'][i18n.language]}</a>
                    }
                </>
            }
        </div>
    )
}